<h5>Certificado Digital</h5>
<p>Introduce el nombre del certificado digital (opcional)</p>
<div [formGroup]="formFirma">
  <div class="input-flex">
    <label for="nombreCertificado" style="font-weight: 500;">Certificado Digital:</label>
    <input class="texto" type="text" formControlName="nombreCertificado" id="nombreCertificado">
  </div>
</div>
